import React, { useState } from 'react'
import swal from 'sweetalert';
import styles from './index.module.scss'
import ModalComponent from '../../../../components/ModalComponent';

const ResourceItem = ({title, image, file_download, text_files, audio_files}) => {
    const [openModal, setOpenModal] = useState(false);

    const handleResourceDownload = () => {
        swal({
            title: `Download ${title}`,
            text: `${title} resources would be available, during and after the conference`,
            icon: "info",
        });
    }

    return (
        <>
            <div 
                className={styles.resources_item}  
                // onClick={() => setOpenModal(true)}
                onClick={handleResourceDownload}
                >
                <div className={styles.resources_image}>
                    <img src={image} alt={title}/>
                </div>
                <div className={styles.resources_name}>
                    <h2>{title}</h2>
                </div>
            </div>
            {openModal ? <ModalComponent setOpenModal={setOpenModal} title={title} file_download={file_download} text_files={text_files} audio_files={audio_files}/> : null}
        </>
    )
}

export default ResourceItem